import {SectionPadding} from '@/section';
import {withBgNeutral900, withNeutral100, withNeutral200, withNeutral500} from '@/hocs/withColors';
import {withHeadingEyebrow, withHomeSubP} from '@/hocs/withFontType';
import {withMarginBottomXl} from '@/hocs/withSpacing';
import Container from '@/container';
import {Grid, Row, Col} from '@/grid';
import {H2, H3, P, PNoMargin} from '@/typography';
import {useTranslations} from 'next-intl';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import PictureWrapper from '@/ui/images-wrapper';

const imgPath = '/static/images/home/ai-section/';

const mcpResponsiveImages = {
  desktopImageUrl: 'mcp-desktop',
  mobileImageUrl: 'mcp-mobile'
};

const Neutral900Section = withBgNeutral900(SectionPadding);
const EyebrowNeutral500 = withNeutral500(withHeadingEyebrow(P));
const H2Neutral100 = withNeutral100(H2);
const SubPNeutral200 = withNeutral200(withHomeSubP(PNoMargin));
const TitleBlock = withMarginBottomXl('div');

const AiSection = () => {
  const t = useTranslations('homepage.aiSection');
  return (
    <Neutral900Section>
      <Container>
        <Grid fluid>
          <Row center="xs">
            <Col xs={12} md={10}>
              <EyebrowNeutral500>{t('eyebrow')}</EyebrowNeutral500>
              <H2Neutral100>{t('title')}</H2Neutral100>
              <TitleBlock>
                <SubPNeutral200>{t('subtitle')}</SubPNeutral200>
              </TitleBlock>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
                <GridLayout Col={3} lgCol={2} autoRows>
                  <GridItem Col={2} Row={2} lgCol={2} lgRow={1}>
                    <PictureWrapper
                      imgPath={imgPath}
                      responsiveImages={mcpResponsiveImages}
                      imageTypeFallback="jpg"
                      altImage={t('imageAlt')}
                      rounded
                    />
                  </GridItem>
                  <GridItem Col={1} lgCol={1}>
                    <BoxGrid
                      backgroundColor="var(--neutral100)"
                      Url={t('box1.url')}
                      UrlCopy={t('box1.urlCopy')}
                      target="_blank">
                      <H3>{t('box1.title')}</H3>
                      <P>{t('box1.description')}</P>
                    </BoxGrid>
                  </GridItem>
                  <GridItem Col={1} lgCol={1}>
                    <BoxGrid backgroundColor="var(--neutral100)">
                      <H3>{t('box2.title')}</H3>
                      <PNoMargin>{t('box2.description')}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                </GridLayout>

                <GridLayout Col={2} autoRows>
                  <GridItem>
                    <BoxGrid backgroundColor="var(--neutral100)">
                      <H3>{t('box3.title')}</H3>
                      <PNoMargin>{t('box3.description')}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                  <GridItem>
                    <BoxGrid backgroundColor="var(--neutral100)">
                      <H3>{t('box4.title')}</H3>
                      <PNoMargin>{t('box4.description')}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                </GridLayout>
            </Col>
          </Row>
        </Grid>
      </Container>
    </Neutral900Section>
  );
};

export default AiSection;
